// src/Dashboard/pages/user/PassageCeintureDocuments/components/PassageCeintureDocumentCard.jsx

import React from "react";
import {
  FaEdit,
  FaEye,
  FaFilePdf,
  FaImage,
  FaTrash,
} from "react-icons/fa";

import {
  htmlToText,
  isQuillEmpty,
  toAbsoluteUrl,
  truncate,
} from "../utils/passageCeintureDocumentsUtils";

export default function PassageCeintureDocumentCard({
  document,
  canManage,
  onOpen,
  onEdit,
  onDelete,
}) {
  const imageUrl = toAbsoluteUrl(document?.image_url);
  const pdfUrl = toAbsoluteUrl(document?.pdf_url);
  const hasDescription = !isQuillEmpty(document?.description);
  const description = truncate(htmlToText(document?.description), 120);

  return (
    <article className="group overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:border-slate-800 dark:bg-slate-950">
      <button
        type="button"
        onClick={onOpen}
        className="relative block h-44 w-full overflow-hidden bg-slate-100 text-left dark:bg-slate-900"
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={document?.titre || "Document"}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
            onError={(event) => {
              event.currentTarget.src = "/img/no-image.jpg";
            }}
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-slate-400">
            <FaImage className="text-4xl" />
          </div>
        )}

        <div className="absolute left-3 top-3">
          <span className="inline-flex rounded-full bg-slate-950/80 px-3 py-1 text-xs font-bold text-white shadow-sm">
            {document?.ceinture || "Sans ceinture"}
          </span>
        </div>

        {!document?.is_published && (
          <div className="absolute right-3 top-3">
            <span className="inline-flex rounded-full bg-amber-500 px-3 py-1 text-xs font-bold text-white shadow-sm">
              Brouillon
            </span>
          </div>
        )}
      </button>

      <div className="flex min-h-[230px] flex-col p-4">
        <div className="flex-1">
          <h3 className="line-clamp-2 text-base font-bold text-slate-900 dark:text-white">
            {document?.titre || "Sans titre"}
          </h3>

          <p className="mt-2 min-h-[60px] text-sm leading-6 text-slate-600 dark:text-slate-300">
            {hasDescription ? description : "Aucune description disponible."}
          </p>
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={onOpen}
            className="inline-flex items-center gap-2 rounded-2xl bg-slate-100 px-3 py-2 text-sm font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-700"
          >
            <FaEye />
            Voir
          </button>

          {pdfUrl && (
            <a
              href={pdfUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-2xl bg-red-50 px-3 py-2 text-sm font-bold text-red-700 ring-1 ring-red-200 transition hover:bg-red-100 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/20"
            >
              <FaFilePdf />
              PDF
            </a>
          )}
        </div>

        {canManage && (
          <div className="mt-4 grid grid-cols-2 gap-2 border-t border-slate-200 pt-4 dark:border-slate-800">
            <button
              type="button"
              onClick={onEdit}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-3 py-2 text-sm font-bold text-white transition hover:bg-indigo-800"
            >
              <FaEdit />
              Modifier
            </button>

            <button
              type="button"
              onClick={onDelete}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-red-600 px-3 py-2 text-sm font-bold text-white transition hover:bg-red-700"
            >
              <FaTrash />
              Supprimer
            </button>
          </div>
        )}
      </div>
    </article>
  );
}